"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardPickerContent = function CardPickerContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _ref.otherProps;
  return /*#__PURE__*/_react.default.createElement(StyledCardPickerContent, _extends({
    className: className
  }, otherProps), children);
};

var StyledCardPickerContent = _styledComponents.default.div.withConfig({
  displayName: "StyledCardPickerContent"
})(["padding:2.4rem;"]);

CardPickerContent.propTypes = {
  /** The content to be displayed. */
  children: _propTypes.element.isRequired,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = CardPickerContent;
exports.default = _default;